import { render, staticRenderFns } from "./ResponsiveDataTable.vue?vue&type=template&id=2f225a54"
import script from "./ResponsiveDataTable.vue?vue&type=script&lang=js"
export * from "./ResponsiveDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports